import { useParams, Link } from "react-router-dom";
import video from "../Assets/om internet services.mp4";

const ServiceDetail = () => {
  const { slug } = useParams();

  const service = {
    "digital-marketing": {
      title: "Digital Marketing",
      desc: "We help brands grow using SEO, Google Ads, Social Media & Performance Marketing.",
    },
  }[slug];

  if (!service) return <div className="p-10">Service Not Found</div>;

  return (
    <div className="bg-white text-black">

      <section className="relative h-[100vh] overflow-hidden">

        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={video} type="video/mp4" />
        </video>

        <div className="absolute inset-0 bg-black/60"></div>

      </section>
      <section className="py-24 px-6 text-center max-w-6xl mx-auto">

        <p className="text-red-500 uppercase tracking-[6px] text-sm">
          Premium Digital Agency
        </p>

        <h1 className="mt-4 text-5xl font-bold">
          {service.title}
        </h1>

        <p className="mt-6 text-gray-600 text-lg max-w-3xl mx-auto">
          {service.desc} We don’t just run campaigns — we build digital growth systems for your business.
        </p>

      </section>
      <section className="py-20 bg-gray-50 px-6">

        <div className="max-w-5xl mx-auto text-center">

          <h2 className="text-3xl font-bold">
            Why {service.title} Matters?
          </h2>

          <p className="mt-6 text-gray-600 leading-relaxed">
            In today’s digital world, visibility is everything. Our marketing strategies
            help you reach the right audience, increase engagement, and convert visitors
            into loyal customers using data-driven techniques.
          </p>

        </div>

      </section>
      <section className="py-24 px-6">

        <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8">

          {[
            ["🚀 More Traffic", "Increase organic & paid traffic"],
            ["💰 More Leads", "Convert visitors into customers"],
            ["📈 More Sales", "Boost revenue with smart strategy"],
          ].map((item, i) => (
            <div
              key={i}
              className="p-8 border rounded-2xl hover:shadow-2xl transition hover:-translate-y-2"
            >
              <h3 className="text-xl font-semibold">{item[0]}</h3>
              <p className="text-gray-600 mt-3">{item[1]}</p>
            </div>
          ))}

        </div>

      </section>

      <section className="py-24 bg-gray-50 px-6">

        <div className="text-center mb-14">
          <h2 className="text-3xl font-bold">Our Process</h2>
          <p className="text-gray-500 mt-2">
            Simple steps to grow your business
          </p>
        </div>

        <div className="max-w-6xl mx-auto grid md:grid-cols-4 gap-6">

          {[
            ["01", "Research"],
            ["02", "Strategy"],
            ["03", "Execution"],
            ["04", "Growth"],
          ].map((item, i) => (
            <div key={i} className="text-center p-6 bg-white rounded-xl shadow-sm">
              <div className="text-2xl font-bold text-red-500">{item[0]}</div>
              <div className="mt-2 font-semibold">{item[1]}</div>
            </div>
          ))}

        </div>

      </section>

      <section className="py-28 bg-black text-white text-center">

        <h2 className="text-4xl font-bold">
          Ready to Scale Your Business?
        </h2>

        <p className="text-gray-400 mt-3 max-w-2xl mx-auto">
          Let’s build a powerful digital presence that brings real results for your brand.
        </p>

        <Link
          to="/contact"
          className="inline-block mt-8 px-10 py-3 bg-red-600 rounded-full hover:bg-red-700 transition"
        >
          Start Now
        </Link>

      </section>

    </div>
  );
};

export default ServiceDetail;